import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import services from '@/services/services'

const useRating = ({ trackingId }) => {
  const [rating, setRating] = useState(null)
  const [hoverRating, setHoverRating] = useState(null)
  const { loading, fetchData } = useFetch(services.sendRating, { doInitialRequest: false })
  const [ratingSubmitted, setRatingSubmitted] = useState(false)

  const isSelected = position => {
    return position <= (hoverRating || rating)
  }

  const onSelect = value => {
    if (!ratingSubmitted) {
      setRating(value)
    }
  }

  const onSubmit = async () => {
    await fetchData({ trackingId, rating })
    setRatingSubmitted(true)
  }

  const handleHoverRating = value => {
    if (!ratingSubmitted) {
      setHoverRating(value)
    }
  }

  return {
    rating,
    hoverRating,
    isSelected,
    onSelect,
    setHoverRating,
    submitting: loading,
    onSubmit,
    handleHoverRating,
    ratingSubmitted,
  }
}

export default useRating
